import { useAppSelector } from 'app/store';
import { TenantAdminRoles } from '../../constants';

export function isBottomFromTenantAdmin() {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.some((role) => TenantAdminRoles.includes(role));
}
